function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var COVERAGE_LAYER_ID = 'LayerListCoverageLayer';
var COVERAGE_FEATURE_STYLE = {
  stroke: {
    color: 'rgba(211, 187, 27, 0.8)',
    width: 2
  },
  fill: {
    color: 'rgba(255,222,0, 0.6)'
  }
};
var LOCALIZATION_BUNDLE_ID = 'MapModule';
var COVERAGE_TOOL_PLUGIN_NAME = 'CoverageToolPlugin';
export var CoverageHelper = /*#__PURE__*/function () {
  function CoverageHelper() {
    _classCallCheck(this, CoverageHelper);
  }
  return _createClass(CoverageHelper, [{
    key: "addCoverageTool",
    value: function addCoverageTool(layer) {
      var _this = this;
      var coverageTool = Oskari.clazz.create('Oskari.mapframework.domain.Tool');
      coverageTool.setName('coverageTool');
      coverageTool.setTitle(Oskari.getMsg(LOCALIZATION_BUNDLE_ID, 'layerCoverageTool.name'));
      coverageTool.setCallback(function () {
        return _this.showLayerCoverage(layer);
      });
      layer.addTool(coverageTool);
      this.initCoverageToolPlugin();
    }
  }, {
    key: "initCoverageToolPlugin",
    value: function initCoverageToolPlugin() {
      var mapModule = Oskari.getSandbox().findRegisteredModuleInstance('MainMapModule');
      if (!this.pluginAlreadyRegistered(mapModule, COVERAGE_TOOL_PLUGIN_NAME)) {
        var coverageToolPlugin = Oskari.clazz.create('Oskari.mapframework.bundle.mapmodule.plugin.CoverageToolPlugin');
        mapModule.registerPlugin(coverageToolPlugin);
        mapModule.startPlugin(coverageToolPlugin);
      }
    }
  }, {
    key: "pluginAlreadyRegistered",
    value: function pluginAlreadyRegistered(mapModule, pluginName) {
      var allInstances = mapModule.getPluginInstances();
      return !!allInstances && !!allInstances[pluginName];
    }
  }, {
    key: "clearLayerCoverage",
    value: function clearLayerCoverage(unregisterPlugin) {
      Oskari.getSandbox().postRequestByName('MapModulePlugin.RemoveFeaturesFromMapRequest', [null, null, COVERAGE_LAYER_ID]);
      if (unregisterPlugin) {
        var mapModule = Oskari.getSandbox().findRegisteredModuleInstance('MainMapModule');
        if (this.pluginAlreadyRegistered(mapModule, COVERAGE_TOOL_PLUGIN_NAME)) {
          var plugin = mapModule.getPluginInstances()[COVERAGE_TOOL_PLUGIN_NAME];
          mapModule.unregisterPlugin(plugin);
        }
      }
    }
  }, {
    key: "showLayerCoverage",
    value: function showLayerCoverage(layer) {
      this.clearLayerCoverage();
      var opts = {
        centerTo: true,
        clearPrevious: true,
        layerId: COVERAGE_LAYER_ID,
        featureStyle: COVERAGE_FEATURE_STYLE
      };
      Oskari.getSandbox().postRequestByName('MapModulePlugin.AddFeaturesToMapRequest', [layer.getGeometryWKT(), opts]);
    }
  }, {
    key: "showMetadataCoverage",
    value: function showMetadataCoverage(geometry, displayedMetadataCoverageId) {
      var attributes = {
        displayedMetadataCoverageId: displayedMetadataCoverageId
      };
      this.clearLayerCoverage();
      var opts = {
        centerTo: true,
        clearPrevious: true,
        layerId: COVERAGE_LAYER_ID,
        featureStyle: COVERAGE_FEATURE_STYLE,
        attributes: attributes
      };
      Oskari.getSandbox().postRequestByName('MapModulePlugin.AddFeaturesToMapRequest', [geometry, opts]);
    }
  }]);
}();